import { useSuspenseQuery } from "@tanstack/react-query";
import type { ListActions } from "src/system/module.types.ts";
import { fetchResourceListActionsConfig } from "src/system/fetchResourceListActionsConfig.tsx";
import { useClientConfig } from "src/client-config/useClientConfig.ts";

export const useModuleListActions = ({ resource }: { resource: string }) => {
  const clientConfig = useClientConfig();
  return useSuspenseQuery<ListActions>({
    queryKey: ["resourceListActions", resource, clientConfig],
    queryFn: () => {
      return fetchResourceListActionsConfig({ resource, clientConfig });
    },
  });
};
